import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
// Import translation JSON files
import enTranslation from "@assets/locales/en/common.yaml";
import deTranslation from "@assets/locales/de/common.yaml";
import enLodgepurchase from "@assets/locales/en/lodgepurchase.yaml";
import deLodgepurchase from "@assets/locales/de/lodgepurchase.yaml";
import enStatus from "@assets/locales/en/status.yaml";
import deStatus from "@assets/locales/de/status.yaml";
import enUsermenu from "@assets/locales/en/usermenu.yaml";
import deUsermenu from "@assets/locales/de/usermenu.yaml";
import enMandant from "@assets/locales/en/mandant.yaml";
import deMandant from "@assets/locales/de/mandant.yaml";
import enUser from "@assets/locales/en/user.yaml";
import deUser from "@assets/locales/de/user.yaml";
import deLog from "@assets/locales/de/log.yaml";
import enLog from "@assets/locales/en/log.yaml";
import deStatistics from "@assets/locales/de/statistics.yaml";
import enStatistics from "@assets/locales/en/statistics.yaml";
import enAkzsReq from "@assets/locales/en/akzsreq.yaml";
import deAkzsReq from "@assets/locales/en/akzsreq.yaml";
import enRequestPurchaseIds from "@assets/locales/en/requestPurchaseIds.yaml";
import deRequestPurchaseIds from "@assets/locales/de/requestPurchaseIds.yaml";
import enAkzs from "@assets/locales/en/akzs.yaml";
import deAkzs from "@assets/locales/de/akzs.yaml";
import enProcessPurchase from "@assets/locales/en/purchaseprocessids.yaml";
import deProcessPurchase from "@assets/locales/de/purchaseprocessids.yaml";
import deProcessPurchaseResult from "@assets/locales/de/processpurchaseresult.yaml";
import enProcessPurchaseResult from "@assets/locales/en/processpurchaseresult.yaml";
import deError from "@assets/locales/de/error.yaml";
import enError from "@assets/locales/en/error.yaml";
import deAddress from "@assets/locales/de/address.yaml";
import enAddress from "@assets/locales/en/address.yaml";
import deOptions from "@assets/locales/de/options.yaml";
import enOptions from "@assets/locales/en/options.yaml";
// Initialize i18n
i18n
    .use(LanguageDetector) // Automatically detects user's language
    .use(initReactI18next) // Connects with React
    .init({
    resources: {
        en: {
            common: enTranslation,
            lodgepurchase: enLodgepurchase,
            status: enStatus,
            usermenu: enUsermenu,
            mandant: enMandant,
            user: enUser,
            log: enLog,
            statistics: enStatistics,
            akzsreq: enAkzsReq,
            requestPurchaseIds: enRequestPurchaseIds,
            akzs: enAkzs,
            processPurchase: enProcessPurchase,
            processPurchaseResult: enProcessPurchaseResult,
            error: enError,
            address: enAddress,
            options: enOptions,
        },
        de: {
            common: deTranslation,
            lodgepurchase: deLodgepurchase,
            status: deStatus,
            usermenu: deUsermenu,
            log: deLog,
            mandant: deMandant,
            user: deUser,
            statistics: deStatistics,
            akzsreq: deAkzsReq,
            requestPurchaseIds: deRequestPurchaseIds,
            akzs: deAkzs,
            processPurchase: deProcessPurchase,
            processPurchaseResult: deProcessPurchaseResult,
            error: deError,
            address: deAddress,
            options: deOptions,
        },
    },
    fallbackLng: "de", // Default language
    ns: [
        "common",
        "lodgepurchase",
        "status",
        "usermenu",
        "log",
        "mandant",
        "user",
        "statistics",
        "akzsreq",
        "requestPurchaseIds",
        "processPurchase",
        "error",
        "address",
        "options",
    ],
    defaultNS: "common",
    interpolation: {
        escapeValue: false, // React already escapes values
    },
});
export default i18n;
